var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1028,
    height: 1054,
    viewBox: "0 0 1028 1054",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.139 966.775C239.159 962.105 299.359 947.805 285.989 907.06C271.349 862.4 218.349 863.67 192.109 870.73C165.869 877.8 119.889 909.63 133.899 945.085C149.049 983.375 196.239 971.195 217.139 966.775Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.79 961.485C273.657 961.485 287.33 947.815 287.33 930.945C287.33 914.083 273.657 900.41 256.79 900.41C239.923 900.41 226.25 914.083 226.25 930.945C226.25 947.815 239.923 961.485 256.79 961.485Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.499 915.4C230.499 915.4 226.409 893.27 230.499 891.75C234.589 890.24 245.919 902.4 245.919 902.4C245.919 902.4 240.579 904.27 237.299 907.43C234.019 910.59 230.499 915.4 230.499 915.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M278.43 909.4C278.43 909.4 303.14 905.89 303.81 911.61C304.48 917.33 286.98 926.34 286.98 926.34C286.98 926.34 285.58 919.01 283.08 915.4C280.58 911.79 278.43 909.4 278.43 909.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.49 898.03C147.49 898.03 119.55 924.06 126.7 955.185C134.33 988.385 195.93 1010.58 222.39 977.395C243.59 950.815 207.92 936.015 197.16 952.835C182.06 976.425 117.21 978.225 147.49 898.03Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.3 931.625C237.3 931.625 218.53 928.595 207.09 932.805",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274.709 942.905C274.709 942.905 290.679 951.705 293.549 955.185",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.299 937.015C237.299 937.015 220.729 936.675 209.449 942.065",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M271.43 949.045C271.43 949.045 286.82 961.395 289.6 970.735",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M274.709 614.68L787.979 609.64",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M638.59 891.62L755.269 890.23L745.829 925.42L638.59 925.68V891.62Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M361.398 459.74C361.398 459.74 325.688 509.71 333.768 550.09C341.838 590.46 388.239 617.22 459.939 614.69C453.879 675.25 464.829 893.3 464.829 893.3L638.588 891.62L739.529 890.22V597.01L598.768 488.4C598.758 488.41 531.638 461.47 361.398 459.74Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M541.689 512.74L631.519 594.5L638.589 891.62",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M450.85 893.42L662.14 891.62L654.07 925.62L461.63 926.34L450.85 893.42Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M729.429 925.68V949.045L790.889 992.595L638.59 993.925V925.68H729.429Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M465.988 926.34L638.588 925.68V951.315L699.668 993.185L467.538 995.955L465.988 926.34Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M497.389 424.48L501.819 374.46L540.179 345.72C540.179 345.72 490.219 276.05 468.009 272.52C455.389 281.6 445.299 266.97 445.299 266.97C445.299 266.97 377.359 269.13 359.199 333.73C398.569 346.35 427.139 354.02 427.139 354.02L435.209 322.99L417.549 408.28L497.389 424.48Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M501.819 374.46L497.389 424.48L417.549 408.28L435.209 322.99L427.139 354.02C427.139 354.02 398.569 346.35 359.199 333.73C377.359 269.13 445.299 266.97 445.299 266.97C445.299 266.97 455.389 281.6 468.009 272.52C490.219 276.05 540.179 345.72 540.179 345.72L501.819 374.46ZM501.819 374.46L498.289 321.97",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M359.19 333.72C359.19 333.72 335.1 443.09 339.82 451.17C344.53 459.24 475.79 485.83 510.11 487.06C544.43 488.29 534.26 437.36 523.85 431.48C513.43 425.6 417.55 408.27 417.55 408.27L427.14 354.01L359.19 333.72Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M503.34 373.7L533.76 350.59L557.34 390.61L533.76 431.99L497.43 424.13L503.34 373.7Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M504.598 272.76C526.668 265.31 517.928 223.45 506.108 206.65C485.168 176.87 433.688 181.92 420.308 222.3C417.388 231.1 399.448 234.96 406.428 249.05C411.308 258.89 430.908 253.77 430.908 253.77C430.908 253.77 491.388 277.22 504.598 272.76Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M445.3 266.96L450.6 251.82C450.6 251.82 445.05 244.25 445.3 239.96C445.55 235.67 436.97 238.7 439.24 229.87C441.51 221.04 452.61 230.88 458.17 233.15C463.73 235.42 474.01 230.01 479.37 229.62C483.02 229.35 486.72 232.88 487.77 235.22C489.89 239.97 486.94 246.78 481.39 250.06C475.84 253.34 467.51 253.85 467.51 253.85L466.68 273.4C466.68 273.4 465.51 277.52 454.65 274.52C443.78 271.5 445.3 266.96 445.3 266.96Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1094 489.36H1026.44",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M133.91 1030.03L274.71 489.36",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M149.049 489.36L333.759 1052.74",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M777.379 489.36L965.119 1052.74",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M765.27 1022.46L906.069 489.36",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7188 422.4C77.7188 422.4 58.8788 375.13 32.2988 363.02",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2992 363.02C32.2992 363.02 12.0292 330.8 3.9492 340.14C-7.0808 352.9 32.2992 363.02 32.2992 363.02Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5303 387.38C51.3103 371.76 30.3203 401.46 30.3203 401.46C30.3203 401.46 62.4603 395.88 58.5303 387.38Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2695 304.05C96.0595 351.74 106.65 423.29 106.65 423.29L92.2695 304.05Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2695 304.05C96.0595 351.74 106.65 423.29 106.65 423.29",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9382 258.79C95.9782 258.19 113.848 311.41 91.7082 308.85C72.0782 306.58 89.9382 258.79 89.9382 258.79Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8594 331.43C94.8594 331.43 84.4495 313.9 67.2895 312.55C50.1295 311.2 47.4395 312.55 47.4395 312.55",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7689 310.7C43.6889 290.53 13.6289 314.74 13.6289 314.74C13.6289 314.74 48.8689 324.49 46.7689 310.7Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 354.61C97.5 354.61 105.8 337.89 126.68 326.34C142.49 317.59 151.41 315 151.41 315",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M152.42 315C145.85 290.86 201.54 305.95 201.54 305.95C201.54 305.95 157.09 332.16 152.42 315Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M137.69 423.3C137.69 423.3 136.68 392.45 147.78 383.71",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M186.52 355.4C186.52 355.4 133.06 366.17 146.9 383.7C156.24 395.53 186.52 355.4 186.52 355.4Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M124.449 369.54C136.939 363.68 139.589 400.07 139.589 400.07C139.589 400.07 112.219 375.28 124.449 369.54Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M154.619 422.4H64.1191V489.35H154.619V422.4Z",
    fill: "#565656",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M497.43 489.42L590.14 301.42H839.789L757.709 489.42H497.43Z",
    fill: "#DADADA",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M691.579 386.37C691.579 386.37 681.989 383.76 675.179 388.56C672.229 390.64 662.919 397.9 667.789 403.95C672.659 410.01 681.739 404.71 685.279 399.41C688.809 394.11 691.579 386.37 691.579 386.37Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M952.168 470.35L985.138 215.65L835.668 134.23",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M835.668 134.23L763.408 164.84L837.098 210.6L835.668 134.23Z",
    fill: "#DADADA",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M799.29 209.76C809.85 209.76 818.4 201.204 818.4 190.65C818.4 180.096 809.85 171.54 799.29 171.54C788.74 171.54 780.18 180.096 780.18 190.65C780.18 201.204 788.74 209.76 799.29 209.76Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.05 467.73H902.998V488.36H1000.05V467.73Z",
    fill: "#DADADA",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M677.929 173.8L667.539 166.73C667.539 166.73 642.179 196.76 649.999 202.94C658.559 209.71 677.929 173.8 677.929 173.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M685.479 173.96C698.469 173.96 708.999 163.43 708.999 150.44C708.999 137.45 698.469 126.92 685.479 126.92C672.49 126.92 661.959 137.45 661.959 150.44C661.959 163.43 672.49 173.96 685.479 173.96Z",
    fill: "#DADADA",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M685.479 165.52C693.178 165.52 699.419 159.279 699.419 151.58C699.419 143.881 693.178 137.64 685.479 137.64C677.78 137.64 671.539 143.881 671.539 151.58C671.539 159.279 677.78 165.52 685.479 165.52Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M653.1 186.69C653.1 186.69 652.91 191 656.13 194.41C657.96 196.35 661.72 197.4 661.72 197.4C661.72 197.4 654.49 206.9 649.95 202.74C645.4 198.57 653.1 186.69 653.1 186.69Z",
    fill: "#DADADA",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 87.29C461.947 87.29 475.58 73.657 475.58 56.84C475.58 40.023 461.947 26.3901 445.13 26.3901C428.313 26.3901 414.68 40.023 414.68 56.84C414.68 73.657 428.313 87.29 445.13 87.29Z",
    fill: "#DADADA",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M468.69 37.5601C481.08 39.4601 489.93 44.7701 491.27 52.3201C493.43 64.4901 475.02 75.7101 450.51 80.0601C426 84.4101 404.65 80.2301 402.49 68.0601C401.29 61.2701 406.4 54.0901 415.42 48.3301",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M489.538 14.7801C493.067 14.7801 495.928 11.9193 495.928 8.3902C495.928 4.8611 493.067 2 489.538 2C486.009 2 483.148 4.8611 483.148 8.3902C483.148 11.9193 486.009 14.7801 489.538 14.7801Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M390.038 97.81C393.567 97.81 396.428 94.949 396.428 91.42C396.428 87.891 393.567 85.03 390.038 85.03C386.509 85.03 383.648 87.891 383.648 91.42C383.648 94.949 386.509 97.81 390.038 97.81Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M208.929 198.15C223.046 198.15 234.489 186.706 234.489 172.59C234.489 158.474 223.046 147.03 208.929 147.03C194.813 147.03 183.369 158.474 183.369 172.59C183.369 186.706 194.813 198.15 208.929 198.15Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M215.999 181.5L202.209 178.3",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M222.398 174.27L214.148 164.51",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M196.99 174.27C196.99 174.27 194.47 170.23 196.15 167.71C197.83 165.19 202.21 167.71 202.21 167.71C202.21 167.71 202.21 160.98 204.57 159.13C206.44 157.66 210.96 160.64 210.96 160.64",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M235.35 176.28C235.35 176.28 241.24 178.3 240.9 181.5C240.56 184.7 226.43 201.52 223.24 201.86C220.04 202.2 217.32 196.75 217.32 196.75C217.32 196.75 226.08 193.28 229.12 188.28C232.15 183.27 235.35 176.28 235.35 176.28Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M239.979 185.27C239.979 185.27 245.449 185.54 244.939 188.74C244.429 191.94 232.789 205.42 229.119 203.63C226.369 202.28 226.119 200.17 227.709 198.59C230.319 196 239.979 185.27 239.979 185.27Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M244.339 191.48L252.589 198.92C252.589 198.92 246.679 207.08 244.969 206.91C243.249 206.74 235.469 201.37 235.469 201.37L244.339 191.48Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M272.439 147.03C272.439 147.03 296.659 115.3 340.069 88.5601L272.439 147.03Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M272.439 147.03C272.439 147.03 296.659 115.3 340.069 88.5601",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M288.68 149.54C288.68 149.54 304.33 125.99 331.24 106.47L288.68 149.54Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M288.68 149.54C288.68 149.54 304.33 125.99 331.24 106.47",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M545.389 64.24C545.389 64.24 588.789 67.6 632.199 107.98",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M562.129 83C562.129 83 592.919 90.07 623.699 115.55",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDark);
export default __webpack_public_path__ + "static/media/empty-dark.9190c18119fa2575fcae20f4dd06e898.svg";
export { ForwardRef as ReactComponent };